module.exports = __webpack_public_path__ + "static/wire-product-3-e3b9053af63f7777190a4b5480fd0554.png";